import { render, staticRenderFns } from "./reprintDialog1.vue?vue&type=template&id=1afdee4e&scoped=true&"
import script from "./reprintDialog1.vue?vue&type=script&lang=js&"
export * from "./reprintDialog1.vue?vue&type=script&lang=js&"
import style0 from "./reprintDialog1.vue?vue&type=style&index=0&id=1afdee4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdee4e",
  null
  
)

export default component.exports